import {FilterStore} from 'app/store/filters/FilterStore';
import GameInterface from 'app/interfaces/GameInterface';
import {prepareFiltersQuery} from 'app/utils/prepareFiltersQuery';
import {makeObservable, override} from 'mobx';
import getCookies from 'app/utils/getCookies';

export class ResultsFilterStore extends FilterStore {
    constructor(games: GameInterface[]) {
        super('r', games);
        this.appliedFilters = getCookies(`${this.filterType}Filters`, []);
        makeObservable(this);
    }

    @override
    get queryNavigateParams(): Record<string, string> {
        const filters = prepareFiltersQuery(this.filters);

        return {
            r24h: this.only24h.toString(),
            rDisc: this.discipline,
            rEvent: this.currentEvents,
            rSport: filters,
            rType: this.betType,
            rUp: this.onlyUpcomingMatches.toString()
        };
    }
}


